/*
  Carries "Production lead time" onto the order when the product option app
  (Easify) adds the item to the cart.

  WHY THIS EXISTS (9 Oct 2026)
  snippets/buy-buttons.liquid puts a hidden "Production lead time" field in the
  product form. Dawn's own Add to cart sends it, so plain orders record it. But
  when a shopper picks gift wrapping or personalization, Easify builds its own
  cart request and leaves that field out — every Easify order on 9 Oct
  (#2263, #2264, #2266, #2267, #2270) arrived without it.

  HOW
  At the moment of the cart request, this file reads each product form on the
  page: the variant currently selected (the form's "id" field) and that form's
  hidden "Production lead time" field. It wraps fetch and XMLHttpRequest, and
  ONLY for requests to /cart/add it adds the lead time to a line whose variant
  id matches a form's selected variant and does not already carry it. Add-on
  lines (gift wrapping, personalization) never match, so they are untouched.

  SAFETY RULES — keep these if you touch this file
  - Fail OPEN. Any parse problem returns the request untouched. This file must
    never stop, delay or alter what gets charged; it only adds one text line.
  - Never duplicates: if the line already has the field (Dawn's normal add),
    it is left alone.
  - Event-free. No DOM observers, no timers (see the 27 Aug 2026 outage notes
    in assets/cart-addons.js).
  - Loaded WITHOUT defer so it wraps fetch before the app's script grabs it.
*/
(function () {
  if (window.__leadTimeCarryLoaded) return;
  window.__leadTimeCarryLoaded = true;

  var KEY = 'Production lead time';
  var FIELD = 'properties[' + KEY + ']';

  function leadTimeMap() {
    var map = {};
    document.querySelectorAll('form[id^="product-form-"]').forEach(function (form) {
      try {
        var lead = form.querySelector('input[name="' + FIELD + '"]');
        var variant = form.querySelector('input[name="id"], select[name="id"]');
        if (!lead || !lead.value || !variant || !variant.value) return;
        map[String(variant.value)] = lead.value;
      } catch (e) {}
    });
    return map;
  }

  function isCartAdd(url) {
    try {
      var path = new URL(String(url), window.location.href).pathname;
      return /\/cart\/add(\.js)?$/.test(path);
    } catch (e) {
      return false;
    }
  }

  function fixItem(item, map) {
    if (!item || item.id == null) return false;
    var value = map[String(item.id)];
    if (!value) return false;
    if (!item.properties || typeof item.properties !== 'object') item.properties = {};
    if (item.properties[KEY]) return false;
    item.properties[KEY] = value;
    return true;
  }

  function fixParams(params, map) {
    var id = params.get('id');
    var value = id ? map[String(id)] : null;
    if (value && !params.has(FIELD)) {
      params.append(FIELD, value);
      return true;
    }
    return false;
  }

  function fixBody(body) {
    try {
      if (body == null) return body;
      var map = leadTimeMap();
      if (!Object.keys(map).length) return body;

      if (typeof body === 'string') {
        var text = body.trim();
        if (text.charAt(0) === '{') {
          var data = JSON.parse(text);
          var changed = false;
          if (Array.isArray(data.items)) {
            data.items.forEach(function (item) {
              if (fixItem(item, map)) changed = true;
            });
          } else if (fixItem(data, map)) {
            changed = true;
          }
          return changed ? JSON.stringify(data) : body;
        }
        var params = new URLSearchParams(text);
        return fixParams(params, map) ? params.toString() : body;
      }

      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        fixParams(body, map);
        return body;
      }

      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        fixParams(body, map);
        return body;
      }
    } catch (e) {
      console.warn('[lead-time-carry] left request unchanged:', e);
    }
    return body;
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' || input instanceof URL ? input : input && input.url;
        if (isCartAdd(url) && init && init.body != null) {
          init = Object.assign({}, init, { body: fixBody(init.body) });
        }
      } catch (e) {}
      return originalFetch.call(this, input, init);
    };
  }

  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__leadTimeCartAdd = isCartAdd(url);
      } catch (e) {}
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this.__leadTimeCartAdd) {
        try {
          body = fixBody(body);
        } catch (e) {}
        return originalSend.call(this, body);
      }
      return originalSend.apply(this, arguments);
    };
  }
})();
